<template>
    <div class="tabs" :class="{ invalid: validations.$invalid }">
        <span @click="selectTab(TABS.GENERAL);" :class="{ active: activeTab === TABS.GENERAL, error: validations.generalForm.$invalid }">{{
            $t("brand.navigation.general")
        }}</span>
        <span @click="selectTab(TABS.BRAND_ACCESS);" :class="{ active: activeTab === TABS.BRAND_ACCESS, error: validations.accessForm.$invalid }">
            {{ $t("brand.navigation.access") }}
        </span>
        <span
            v-if="estoreDisplay"
            @click="selectTab(TABS.E_STORE);"
            :class="{ active: activeTab === TABS.E_STORE, error: validations.estoreForm.$invalid }"
        >
            {{ $t("brand.navigation.eStore") }}</span
        >
    </div>
</template>

<script>
import { TABS, FORM_TYPE } from "@/components/admin/brand/utils/brandFormUtils";

export default {
    data: () => ({
        TABS,
        FORM_TYPE
    }),
    name: "Navbar",
    model: {
        prop: "activeTab"
    },
    props: {
        activeTab: {
            required: true,
            type: Number,
            default: TABS.GENERAL
        },
        validations: {
            required: true,
            type: Object
        },
        type: {
            required: false,
            type: String
        },
        estoreDisplay: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        selectTab(tab) {
            this.$emit("select-tab", tab);
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../../assets/css/themes";

.tabs {
    margin-bottom: 20px;
    span {
        padding: 10px;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        text-transform: uppercase;
        font-weight: bold;

        &.active {
            border-bottom: $color2 1px solid;
            color: $color2;
        }
        &.error {
            &:after {
                content: "*";
                color: red;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?a49e3e98